import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GET_TOP_OPERATE } from "../../../constant-value";
import api from "../../../services/axiosConfig";
import { calculateDateDiff } from "../../pages/dateDiff";
import CardTwoSide from "../card-two-side";

const OperateHome = () => {
  const [operate, setOperate] = useState([]);
  const [isLoadingOp, setIsLoadingOp] = useState(true);

  const getOperats = () => {
    api
      .get(`${GET_TOP_OPERATE}`)
      .then((response) => setOperate(response.data.operates))
      .catch((reason) => alert(reason))
      .finally(() => setIsLoadingOp(false));
  };

  useEffect(getOperats, []);

  if (isLoadingOp) return <p>در حال بارگذاری...</p>;
  if (operate.length === 0) {
    // return <Link to={'/add-service'} className="btn btn-success btn-sm flex-grow-1 mx-1">ثبت</Link>;
    return (
        <>
          <Link
            type="button"
            className="btn btn-info btn-lg text-white w-100"
            to={'/add-service'}
          >
            سرویس جدید
          </Link>
          
          {/* <div
            className={`alert alert-success text-center shadow-sm p-4 rounded`}
            role="alert"
            style={{ maxWidth: "420px", width: "100%" }}
          >
            <Link
              type="button"
              className="btn btn-info btn-lg w-100"
              to={'/add-service'}
            >
              سرویس جدید
            </Link>
          </div> */}
        </>
    );
  }

  return (
    <div className="container my-3">
      <div className="row g-3">
        {operate.map((service) => {
          const result = calculateDateDiff(service);
          return (
            <div
              key={service.id}
              className="col-12 col-sm-6 col-lg-4 col-xl-3"
            >
              <CardTwoSide
                // serviceType={service.ok_serviceType}
                // serviceTitle={service.opTitle}
                // categoryId={service.ok_id}
                // remain={service.remain}
                // beforService={service.lastDateP}
                // afterService={service.programDateP}
                // lastDate={service.lastKm}
                // carTitle={service.car_title}
                service={service}
                min={result.min}
                max={result.max}
                now={result.now}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OperateHome;
